const imageSizes = {
    '1x': '288x162',
    '2x': '576x324'
};

const pixelRatio = window.devicePixelRatio || 1;
const imagePixelRatio = pixelRatio >= 2 ? '2x' : '1x';
const imageSize = imageSizes[imagePixelRatio];

const data = require('../config/suggestions');

data.forEach((item) => {
    item.image = item.image.replace('$recipe', imageSize);
});

let offset = 0;
const perPage = 6;

export function load() {
    const newData = data.slice(offset, offset + perPage);

    if (offset + perPage >= data.length) {
        offset = 0;
    } else {
        offset += perPage;
    }

    return newData;
}



/** WEBPACK FOOTER **
 ** ./assets/js/models/suggestions.js
 **/